import { render, staticRenderFns } from "./IconGroupForArticle.vue?vue&type=template&id=cce8f4aa&scoped=true"
import script from "./IconGroupForArticle.vue?vue&type=script&lang=js"
export * from "./IconGroupForArticle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cce8f4aa",
  null
  
)

export default component.exports